var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 22V4C6.66406 3.46957 6.87478 2.96086 7.24985 2.58579C7.62492 2.21071 8.13363 2 8.66406 2H16.6641C17.1945 2 17.7032 2.21071 18.0783 2.58579C18.4533 2.96086 18.6641 3.46957 18.6641 4V22H6.66406Z",
    stroke: "#155DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 12H4.66406C4.13363 12 3.62492 12.2107 3.24985 12.5858C2.87478 12.9609 2.66406 13.4696 2.66406 14V20C2.66406 20.5304 2.87478 21.0391 3.24985 21.4142C3.62492 21.7893 4.13363 22 4.66406 22H6.66406",
    stroke: "#155DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6641 9H20.6641C21.1945 9 21.7032 9.21071 22.0783 9.58579C22.4533 9.96086 22.6641 10.4696 22.6641 11V20C22.6641 20.5304 22.4533 21.0391 22.0783 21.4142C21.7032 21.7893 21.1945 22 20.6641 22H18.6641",
    stroke: "#155DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 6H14.6641",
    stroke: "#155DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 10H14.6641",
    stroke: "#155DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 14H14.6641",
    stroke: "#155DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 18H14.6641",
    stroke: "#155DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/Experience.56ca7c891a5499726c3db173002100a9.svg";
export { ForwardRef as ReactComponent };